import * as api from '../../api';

export const forgotPasswordActions = api.fetchActions('acct', 'create-password-reset');

export const actionTypes = {
  ...forgotPasswordActions.actionTypes,
};

export const requestPasswordReset = (email) => api.postThunk(
  `/sessions/resetpassword`,
  { email },
  forgotPasswordActions,
  {},
  api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/acct/password/forgot-password.actions.js